import { getCurrentLocale } from './locale'
import numberFormats from './numberFormats'

// app-wide i18n message imports
import { messages as enumsMessages } from '@enums'

import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  ...enumsMessages
}

const i18n = new VueI18n({
  locale: getCurrentLocale(),
  fallbackLocale: 'en-US',
  messages,
  numberFormats,
  silentTranslationWarn: true
})

export default i18n
